import { useMemo } from 'react';
import { getObjectValue, RedirectParams } from '../../common/List/List.helpers';

export type QueryParamsConfig = {
  name: string;
  key?: string;
  value?: string;
};

export const useLinkGeneration = (
  url: string,
  refObject?: any,
  includeRedirect?: boolean,
  queryParams?: QueryParamsConfig[],
) => {
  const linkTo = useMemo(() => {
    return getLinkTo(url, refObject);
  }, [url, refObject]);

  const query = useMemo(() => {
    return getQueryString(refObject, queryParams);
  }, [queryParams, refObject]);

  return useMemo(() => {
    return getRedirectLink(linkTo, query, refObject, includeRedirect);
  }, [
    includeRedirect,
    linkTo,
    window.location.pathname,
    window.location.search,
    query,
  ]);
};

export const getLinkTo = (url: string, refObject?: any) => {
  if (!refObject) {
    return url;
  }

  return url.replace(`:${refObject.name}`, refObject.value);
};

export const getQueryString = (
  refObject?: any,
  queryParams?: QueryParamsConfig[],
) => {
  if (!queryParams) {
    return '';
  }

  const params: string[] = [];

  queryParams.map((queryParam) => {
    const objectValue =
      queryParam.value ?? getObjectValue(refObject.object, queryParam.key);

    params.push(`${queryParam.name}=${encodeURIComponent(objectValue)}`);
  });

  return params.join('&');
};

export const getRedirectLink = (
  linkTo: string,
  query: string,
  refObject?: any,
  includeRedirect?: boolean,
) => {
  if (includeRedirect) {
    return `${linkTo}?${RedirectParams.redirectTo}=${encodeURIComponent(
      window.location.pathname + window.location.search,
    )}&${RedirectParams.label}=${encodeURIComponent(refObject?.label ?? '')}${
      query ? `&${query}` : ''
    }`;
  }

  return `${linkTo}${query ? `?${query}` : ''}`;
};
